// JsFromRoutes CacheKey db1132028d787cc82b79588f98ac30eb
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  terminate: /* #__PURE__ */ definePathHelper('post', '/employers/employees/terminate'),
  duplicates: /* #__PURE__ */ definePathHelper('get', '/employers/employees/duplicates'),
  offboard: /* #__PURE__ */ definePathHelper('get', '/employers/employees/offboard'),
  editOffboarding: /* #__PURE__ */ definePathHelper('get', '/employers/employees/:id/edit_offboarding'),
  index: /* #__PURE__ */ definePathHelper('get', '/employers/employees'),
  show: /* #__PURE__ */ definePathHelper('get', '/employers/employees/:id'),
}
